import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import * as Unicons from "@iconscout/react-unicons";

export default function Resume(props) {
  if (!props.data) return null;

  return (
    <section id="resume">
      <VerticalTimeline>
        {props?.data?.work?.map((item, index) => {
          if (index % 2 === 0) {
            return (
              <VerticalTimelineElement
                className="vertical-timeline-element--work"
                date={item?.years}
                dateClassName="!text-2xl font-Interbold"
                contentStyle={{
                  background: "white",
                  color: "black",
                }}
                contentArrowStyle={{ borderRight: "7px solid  white" }}
                iconStyle={{
                  background:
                    item?.type === "work" ? "rgb(33, 150, 243)" : "#4CAF50",
                  color: "#fff",
                }}
                icon={
                  item?.type === "work" ? (
                    <Unicons.UilBriefcase />
                  ) : (
                    <Unicons.UilGraduationCap />
                  )
                }
              >
                <h3 className="vertical-timeline-element-title !font-geist">
                  {item?.title}
                </h3>
                <h4 className="vertical-timeline-element-subtitle font-geist italic">
                  {item?.company}
                </h4>
                <div class="border-t border-gray-200 my-1 !mb-4 h-0.5 bg-gray-200"></div>
                <p
                  dangerouslySetInnerHTML={{ __html: item?.description }}
                  className="!text-2xl font-geist !leading-10"
                ></p>
                <ul className="mt-2 flex flex-wrap">
                  {item?.skills?.map((skill, index) => (
                    <li key={index} className="mr-1.5 mt-2">
                      <div className="flex items-center rounded-full bg-gray-900 px-3 py-1 text-xl font-medium font-geist leading-5 text-white">
                        {skill}
                      </div>
                    </li>
                  ))}
                </ul>
              </VerticalTimelineElement>
            );
          } else {
            return (
              <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{
                  background: "white",
                  color: "black",
                }}
                contentArrowStyle={{
                  borderRight: "7px solid  white",
                }}
                date={item?.years}
                dateClassName="!text-2xl font-Interbold"
                iconStyle={{
                  background:
                    item?.type === "work" ? "rgb(33, 150, 243)" : "#4CAF50",
                  color: "#fff",
                }}
                icon={
                  item?.type === "work" ? (
                    <Unicons.UilBriefcase />
                  ) : (
                    <Unicons.UilGraduationCap />
                  )
                }
              >
                <h3 className="vertical-timeline-element-title !font-geist">
                  {item?.title}
                </h3>
                <h4 className="vertical-timeline-element-subtitle font-geist italic">
                  {item?.company}
                </h4>
                <div class="border-t border-gray-200 my-1 !mb-4 h-0.5 bg-gray-200"></div>
                <p
                  dangerouslySetInnerHTML={{ __html: item?.description }}
                  className="!text-2xl font-geist !leading-10"
                ></p>
                <ul className="mt-2 flex flex-wrap">
                  {item?.skills?.map((skill, index) => (
                    <li key={index} className="mr-1.5 mt-2">
                      <div className="flex items-center rounded-full bg-gray-900 px-3 py-1 text-xl font-medium font-geist leading-5 text-white">
                        {skill}
                      </div>
                    </li>
                  ))}
                </ul>
              </VerticalTimelineElement>
            );
          }
        })}
      </VerticalTimeline>
    </section>
  );
}
